<script setup lang="ts">
export interface StoryblokUiPageLogosItemProps {
    blok: StoryblokUiPageLogosItem;
}

// PROPS
const { blok } = defineProps<StoryblokUiPageLogosItemProps>();

// DATA
const nuxtLink = resolveComponent('NuxtLink');
const to = computed(() => (blok.to ? storyblokResolveLink(blok.to) : undefined));
</script>

<template>
    <component :is="to ? nuxtLink : 'div'" class="flex w-32 max-w-32 shrink-0 grow flex-col items-center gap-2" :to="to">
        <NuxtImg
            v-if="blok.image?.filename"
            format="webp"
            :provider="storyblokImageProvider(blok.image)"
            :src="blok.image.filename"
            :alt="blok.image.alt ?? blok.label ?? ''"
            class="h-10 w-auto object-contain"
            loading="lazy"
        />
        <span v-if="blok.label" class="text-muted text-sm">{{ blok.label }}</span>
    </component>
</template>
